"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformServiceRequest = exports.transformServiceParsedResponse = exports.transformServiceListResponse = exports.transformServiceResponse = void 0;
const Error_1 = require("./Error");
function transformServiceResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isProjectErrorResponse)(status, response)) {
        return (0, Error_1.transformProjectErrorResponse)(response);
    }
    const { service } = response;
    return transformServiceParsedResponse(service);
}
exports.transformServiceResponse = transformServiceResponse;
function transformServiceListResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isProjectErrorResponse)(status, response)) {
        return (0, Error_1.transformProjectErrorResponse)(response);
    }
    const { services, meta } = response;
    const { total, per_page, page, pages } = meta;
    return {
        services: services.map((service) => transformServiceParsedResponse(service)),
        pages: {
            total,
            size: per_page,
            pages,
            page,
        },
    };
}
exports.transformServiceListResponse = transformServiceListResponse;
function transformServiceParsedResponse(service) {
    return {
        businessId: service.business_id,
        id: service.id,
        name: service.name,
        billable: service.billable,
        visState: service.vis_state,
    };
}
exports.transformServiceParsedResponse = transformServiceParsedResponse;
function transformServiceRequest(service) {
    return JSON.stringify({
        service: {
            name: service.name,
        },
    });
}
exports.transformServiceRequest = transformServiceRequest;
//# sourceMappingURL=Service.js.map